export interface Position {
  x: number;
  y: number;
}

export interface CardData {
  id: string;
  type: number; // 0-13 for the 14 different patterns
  position: Position;
  layer: number; // The layer the card belongs to
  visible: boolean; // Whether the card is currently visible (all blockers removed)
  selected: boolean; // Whether the card has been selected/removed from board
  blockedBy: string[]; // IDs of cards that block this card
}

export interface SlotCard {
  id: string;
  type: number;
}

export interface QueueCard {
  id: string;
  type: number;
}

// Types of last move for reversion
export enum LastMoveType {
  NONE = 'none',
  BOARD_CARD = 'board_card',
  LEFT_QUEUE = 'left_queue',
  RIGHT_QUEUE = 'right_queue'
}

// Last move info for reversion
export interface LastMove {
  type: LastMoveType;
  cardId: string;
  cardType: number;
  queueCard?: QueueCard; // Only for queue moves
}

export interface GameState {
  cards: CardData[];
  slots: SlotCard[];
  leftQueue: QueueCard[];
  rightQueue: QueueCard[];
  isGameOver: boolean;
  isGameWon: boolean;
  revivalChances: number; // Number of revival chances left (replaces canRevive)
  lastMove: LastMove | null; // Information about the last move for reversion
  canRevert: boolean; // Whether the player can revert the last move
  usedRevert: boolean;
  usedReshuffle: boolean;
  usedMoveOut: boolean;
} 